export default __webpack_public_path__ + "static/media/wallet.bf1277ed.svg";